import { render, staticRenderFns } from "./DictionaryAdder.vue?vue&type=template&id=13d31636&"
import script from "./DictionaryAdder.vue?vue&type=script&lang=js&"
export * from "./DictionaryAdder.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryAdder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports